import {
  UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_STARTED,
  UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_ENQUEUE_STARTED,
  UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_ENQUEUE_SUCCEEDED,
  UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_PROGRESSED,
  UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_FAILED,
} from '@packages/systems/designer/actions';
import type {DesignerActionFromCreator} from '@packages/systems/designer/flux';
import {createAction} from '@packages/utilities/create-action';
import type {ComponentInstanceUnlinkedPayload} from '@packages/systems/component-unlink';
import type {UnlinkComponentInstanceAcrossLocalesJobPayload} from '@packages/systems/localization-types';

export const unlinkComponentInstanceAcrossLocalesStarted = createAction<
  typeof UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_STARTED,
  ComponentInstanceUnlinkedPayload
>(UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_STARTED);

export type UnlinkComponentInstanceAcrossLocalesStartedAction =
  DesignerActionFromCreator<typeof unlinkComponentInstanceAcrossLocalesStarted>;

export const unlinkComponentInstanceAcrossLocalesEnqueueStarted = createAction<
  typeof UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_ENQUEUE_STARTED,
  Pick<
    UnlinkComponentInstanceAcrossLocalesJobPayload,
    'pageId' | 'componentType' | 'instanceId' | 'initialId'
  >
>(UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_ENQUEUE_STARTED);

export type UnlinkComponentInstanceAcrossLocalesEnqueueStartedAction =
  DesignerActionFromCreator<
    typeof unlinkComponentInstanceAcrossLocalesEnqueueStarted
  >;

export const unlinkComponentInstanceAcrossLocalesEnqueueSucceeded =
  createAction<
    typeof UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_ENQUEUE_SUCCEEDED,
    {taskId: string}
  >(UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_ENQUEUE_SUCCEEDED);

export type UnlinkComponentInstanceAcrossLocalesEnqueueSucceededAction =
  DesignerActionFromCreator<
    typeof unlinkComponentInstanceAcrossLocalesEnqueueSucceeded
  >;

export const unlinkComponentInstanceAcrossLocalesProgressed = createAction<
  typeof UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_PROGRESSED,
  {progress: number}
>(UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_PROGRESSED);

export type UnlinkComponentInstanceAcrossLocalesProgressedAction =
  DesignerActionFromCreator<
    typeof unlinkComponentInstanceAcrossLocalesProgressed
  >;

export const unlinkComponentInstanceAcrossLocalesFailed = createAction<
  typeof UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_FAILED,
  void | {message: string}
>(UNLINK_COMPONENT_INSTANCE_ACROSS_LOCALES_FAILED);

export type UnlinkComponentInstanceAcrossLocalesFailedAction =
  DesignerActionFromCreator<typeof unlinkComponentInstanceAcrossLocalesFailed>;
